import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "AI Innovations Summit",
        details: {
            date: "15 February, 2025",
            time: "9:00 AM",
            location: "Tech Hub",
            organizer: "AI Entrepreneurs Community",
            number: "+123-456-7890",
            email: "info@ainetworking.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at the AI Innovations Summit hosted at Tech Hub. This summit gathers AI leaders, tech innovators, and startup enthusiasts to explore the future of artificial intelligence and business transformation.",
            "Experience keynote sessions, panel discussions, and hands-on workshops designed to equip you with insights on AI-powered solutions driving industries forward."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        highlights: [
            "Keynote Speeches by Industry Pioneers.",
            "Interactive Panel Discussions on AI Ethics and Innovation.",
            "Startup Showcases Highlighting Cutting-edge AI Applications.",
            "Networking Sessions with Investors and Tech Leaders.",
            "Workshops on AI Deployment and Scaling."
        ],
        essentials: [
            "Business Cards for Networking",
            "Laptop/Tablet for Note-taking and Demos",
            "Enthusiasm to Explore AI Opportunities",
            "Passion for Technology and Innovation"
        ],
        guestIds: [1, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.622589899471!2d-6.260309684365894!3d53.34980597997906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9d6c3d63df%3A0x27fbd49abffecb4c!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1626525931747!5m2!1sen!2s"
    },
    {
        id: 2,
        image: images.event2,
        title: "TechTalk Conference",
        details: {
            date: "12 March, 2025",
            time: "10:00 AM",
            location: "Innovation Convention Center",
            organizer: "Global Tech Forum",
            number: "+987-654-3210",
            email: "contact@techtalkconf.com",
            fee: "$50 Admission"
        },
        paragraphs: [
            "Join industry professionals, developers, and business leaders at the TechTalk Conference to explore the latest trends in technology, AI, and digital transformation.",
            "Participate in engaging sessions, product showcases, and expert-led discussions to stay ahead in the evolving tech landscape."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        highlights: [
            "Keynote Presentations from Global Tech Experts.",
            "Interactive Workshops on Emerging Technologies.",
            "Panel Discussions on AI, Cloud, and Cybersecurity.",
            "Networking Lounge for Professional Connections.",
            "Product Demos from Leading Tech Companies."
        ],
        essentials: [
            "Conference Badge for Entry",
            "Laptop/Tablet for Interactive Sessions",
            "Prepared Questions for Speakers",
            "Passion for Technology and Innovation"
        ],
        guestIds: [3, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.622589899471!2d-6.260309684365894!3d53.34980597997906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9d6c3d63df%3A0x27fbd49abffecb4c!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1626525931747!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.event3,
        title: "Cloud Computing Expo",
        details: {
            date: "28 March, 2025",
            time: "11:00 AM",
            location: "Skyline Exhibition Hall",
            organizer: "CloudTech Association",
            number: "+555-123-4567",
            email: "events@cloudexpo.com",
            fee: "$75 Admission"
        },
        paragraphs: [
            "Cloud Computing Expo is the premier event for cloud enthusiasts, IT professionals, and businesses exploring scalable cloud solutions.",
            "Dive deep into workshops, product showcases, and expert sessions covering the latest in cloud infrastructure, SaaS, and serverless technologies."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        highlights: [
            "Workshops on Cloud Migration & Optimization.",
            "Panel Talks on Multi-Cloud Strategies.",
            "Live Demos from Leading Cloud Providers.",
            "Networking Sessions with Industry Leaders.",
            "Insights into Future Cloud Innovations."
        ],
        essentials: [
            "Event Pass for Entry",
            "Laptop/Tablet for Workshop Participation",
            "Cloud Service Account Credentials (Optional)",
            "Eagerness to Explore Cloud Technologies"
        ],
        guestIds: [5, 6],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.622589899471!2d-6.260309684365894!3d53.34980597997906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9d6c3d63df%3A0x27fbd49abffecb4c!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1626525931747!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.event4,
        title: "Startup Growth Forum",
        details: {
            date: "12 April, 2025",
            time: "10:00 AM",
            location: "Innovation Center Hall B",
            organizer: "FutureFounders Network",
            number: "+987-654-3210",
            email: "contact@startupgrowthforum.com",
            fee: "Free Entry (Registration Required)"
        },
        paragraphs: [
            "The Startup Growth Forum brings together aspiring entrepreneurs, venture capitalists, and business mentors for a day of insightful discussions and networking opportunities.",
            "Participants will explore strategies for scaling startups, building resilient business models, and navigating the competitive startup ecosystem."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        highlights: [
            "Keynote Speeches by Industry Leaders.",
            "Workshops on Startup Scaling & Fundraising.",
            "Interactive Q&A with Successful Entrepreneurs.",
            "Networking Lounge for Business Collaborations.",
            "Pitch Your Startup to Angel Investors & VCs."
        ],
        essentials: [
            "Business Presentation Deck (Optional)",
            "Notepad for Idea Sharing",
            "Professional Networking Etiquette",
            "Passion for Startup Growth & Innovation"
        ],
        guestIds: [7, 8],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.622589899471!2d-6.260309684365894!3d53.34980597997906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9d6c3d63df%3A0x27fbd49abffecb4c!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1626525931747!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.event5,
        title: "AI Future Summit",
        details: {
            date: "30 May, 2025",
            time: "9:30 AM",
            location: "Global Tech Arena",
            organizer: "AI Future Alliance",
            number: "+321-654-9870",
            email: "summit@aifuture.org",
            fee: "$50 Early Bird / $100 Regular"
        },
        paragraphs: [
            "The AI Future Summit is a premier gathering of global AI leaders, researchers, and technology enthusiasts. This summit aims to explore the future of artificial intelligence across industries and society.",
            "Attendees will gain access to visionary talks, emerging AI use cases, and collaborative opportunities that will shape the next era of technology innovation."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        highlights: [
            "Keynote Sessions by Global AI Visionaries.",
            "Panels on AI Ethics, Regulation, and Adoption.",
            "Exhibition of Next-Gen AI Technologies.",
            "Workshops on AI Implementation Strategies.",
            "Networking with Researchers, Startups, and Enterprises."
        ],
        essentials: [
            "Event Badge for Entry",
            "Notebook or Digital Device for Notes",
            "Curiosity for Emerging AI Trends",
            "Willingness to Collaborate and Innovate"
        ],
        guestIds: [1, 7],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.622589899471!2d-6.260309684365894!3d53.34980597997906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9d6c3d63df%3A0x27fbd49abffecb4c!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1626525931747!5m2!1sen!2s"
    },
    {
        id: 6,
        image: images.event6,
        title: "AI Impact Discussion",
        details: {
            date: "12 June, 2025",
            time: "2:00 PM",
            location: "Innovation Hall, City Center",
            organizer: "FutureTech Society",
            number: "+789-123-4560",
            email: "contact@futuretechsociety.org",
            fee: "Free Admission (Registration Required)"
        },
        paragraphs: [
            "The AI Impact Discussion brings together thought leaders, policymakers, and AI practitioners to explore the societal implications of artificial intelligence. The focus is on fostering ethical innovation and responsible AI development.",
            "Participants will engage in open discussions, share real-world experiences, and debate the challenges and opportunities AI presents in the modern world."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        highlights: [
            "Open Forums on AI Ethics and Social Impact.",
            "Expert Panels Discussing Future AI Policies.",
            "Real-World Case Studies of AI Applications.",
            "Collaborative Sessions on Building Responsible AI.",
            "Networking Opportunities with Industry and Academia."
        ],
        essentials: [
            "Curiosity and Critical Thinking",
            "Prepared Questions for Panelists",
            "Notebook or Device for Notes",
            "Interest in AI and Society"
        ],
        guestIds: [4, 5],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.622589899471!2d-6.260309684365894!3d53.34980597997906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9d6c3d63df%3A0x27fbd49abffecb4c!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1626525931747!5m2!1sen!2s"
    }

];

export default events;